import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M18.7319 7.2958a1 1 0 0 0-.71-.2958 1 1 0 0 0-.71.2958l-7.45 7.46-3.13-3.14a1.023 1.023 0 0 0-.7277-.2868 1.023 1.023 0 0 0-.7173.3118 1.022 1.022 0 0 0 .025 1.445l3.84 3.84a1 1 0 0 0 .71.2958 1 1 0 0 0 .71-.2958l8.16-8.16a1 1 0 0 0 0-1.47"
}), "Check", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
